import React, { Component } from 'react';
import { Link } from "react-router-dom";

class FooterHelpWidget extends Component {
    state = {
        title: 'Let us help you',
        links: [
            {
                path: '/',
                text: 'Claim your Business'
            },
            {
                path: '/',
                text: 'Business Support'
            },
            {
                path: '/',
                text: 'Advertise Your Products'
            },
            {
                path: '/',
                text: 'Frequently Asked Questions'
            }
        ]
    }
    render() {
        return (
            <>
                <div className="col-lg-2 col-md-2 col-sm-2 column-td-6">
                    <div className="footer-item">
                        <h4 className="footer__title">
                            {this.state.title}
                        </h4>
                        <ul className="list-items">
                            {this.state.links.map((link, index) => {
                                return (
                                    <li key={index}>
                                        <Link to={link.path}  >{link.text}</Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export default FooterHelpWidget;